<template>
  <div class="mobileCardWrapper">
    <div class="header">
      <div class="headerContent">
        <span class="headerSubtitle">Référence : {{ item?.reference }}</span>
      </div>
      <div class="actionsWrapper">
        <div class="elem elem--span-1 elem--clickable">
          <BasicTooltip label="Consulter la facture">
            <BasicIcon
              @click="useRechercheVirementActions().displayVirement(item.code)"
              name="eye"
              :active="false"
            />
          </BasicTooltip>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="contentElement">
        <span class="footerSubtitle">Bénéficiaire</span>
        <span>{{ item?.denominationBeneficiaire }}</span>
      </div>
      <div class="contentElement">
        <span class="footerSubtitle">Montant TTC</span>
        <span>{{ `${formatNumber(item?.montantTTC, { decimal: 2, separateur: true })} €` }}</span>
      </div>
      <div class="contentElement">
        <span class="footerSubtitle">Code facture</span>
        <span>{{ item?.codeFacture }}</span>
      </div>
      <div class="contentElement">
        <span class="footerSubtitle">Code dossier</span>
        <span>{{ item?.codeDossier }}</span>
      </div>
    </div>
    <div class="footer">
      <div class="footerElem">
        <span class="footerTitle">Date de paiement</span>
        <span class="footerSubtitle">{{ dateTimeToReadableDate(item?.dateEmission) }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { VirementDTO } from '@/features/api/extranet/dto/Virement'
  import { dateTimeToReadableDate } from '@/features/shared/tools/date'
  import { formatNumber } from '@/features/shared/tools'
  import { useRechercheVirementActions } from '../useRechercheVirementActions'

  defineProps<{ item: VirementDTO }>()
</script>

<style scoped>
  @import '../../index.less';
  @import './VirementCardMobile.less';
</style>
